const translateSymbol = (symbol) => {
  switch (symbol) {
    case "WINFUT":
      return "Ibovespa";
    case "WDOFUT":
      return "Dólar";
    case "BITFUT":
      return "Bitcoin";
    case "PETR4":
      return "Petrobras";
    case "VALE3":
      return "Vale";
    case "ITUB4":
      return "Itaú Unibanco";
    default:
      return symbol;
  }
};

export default translateSymbol;
